import { render } from "./dateValue.vue?vue&type=template&id=c1b89fb6&ts=true"
import script from "./dateValue.vue?vue&type=script&lang=ts"
export * from "./dateValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__